<template> 
    <div class="mx-auto">
        <nav class="bg-white border-gray-200 px-2 sm:px-4 sm:py-2 py-3 rounded dark:bg-gray-900">
            <div class="container flex flex-wrap items-center justify-between py-6 mx-auto">
                <router-link to="/" class="flex items-center">
                    <img src="/images/Logo1.png" class="" alt="Logo" />
                </router-link>
                <!-- toogle menu -->
                <button type="button" class="inline-flex items-center p-2 ml-3 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"  @click="mobileMenu = !mobileMenu">
                <span class="sr-only">Open main menu</span>
                <svg class="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"></path></svg>
                </button>
                <!-- main menu -->
                <div :class="[mobileMenu ? 'mobile-menu' : 'hidden', 'w-full md:block md:w-auto']" @click="mobileMenu = false">
                    <ul class="flex flex-row p-4 border border-gray-100 rounded-lg bg-white md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium md:border-0 gap-2 list-none">
                        <li>
                            <router-link to="/joblistings" class="block py-3 px-6 bg-white text-black rounded-[25px] top-[47px] left-[548px] text-left font-poppins text-[16px] font-bold">We're Hiring</router-link>
                        </li>
                        <li>
                            <a href="https://www.ipnxnigeria.net/our-company/" class="block py-3 px-6 bg-white text-black rounded-[25px] top-[47px] left-[548px] text-left font-poppins text-[16px] font-bold" target="_blank">Our Company</a>
                        </li>
                        <li>
                            <a href="https://www.ipnxnigeria.net/blog/" class="block py-3 px-6 bg-white text-black rounded-[25px] top-[47px] left-[548px] text-left font-poppins text-[16px] font-bold" target="_blank">Latest News</a>
                        </li>
                    </ul>
                </div>
                <div :class="[mobileMenu ? 'mobile-menu' : 'hidden', 'w-full md:block md:w-auto']" @click="mobileMenu = false">
                    <ul class="flex flex-row p-4 border border-gray-100 rounded-lg bg-white md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium md:border-0 gap-2 list-none">
                        <li>
                            <a href="https://www.ipnxnigeria.net/" class="block py-3 px-6 bg-white text-pigmentred border-pigmentred rounded-[25px] top-[35px] left-[1108px] p-[12px] space-y-[12px] border-[1px] font-bold" target="_blank">Company Website</a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        <div class="grid lg:grid-cols-2 grid-cols-1 gap-5 mx-auto">
            <div class="flex md:flex-row flex-col md:items-center items-start justify-between border border-white rounded p-5">
                <div class="lg:w-full w-full left-content pr-5">
                    <div class="lg:-mt-10">
                        <h1 class="lg:text-[50px] text-black text-[40px] font-bold lg:text-center lg:ml-20 -mt-5">Let's work <span class="text-userGray">together</span></h1>
                        <p class="text-black leading-7 text-[16px] font-poppins mt-3 -pt-5 lg:ml-10 lg:pl-10">We're building a culture at ipNX where amazing people (like you) can do their best work. If you're ready to grow your career and create possibilities, you've come to the right place.</p>
                        <div class="mt-3 lg:ml-20">
                            <router-link to="/joblistings">
                                <button class="md:mt-0 bg-normalRed font-poppins py-2 rounded-[25px] text-white text-[16px] font-medium flex items-center justify-between space-x-0 pl-5">Explore Roles
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-5 w-10 text-white">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                                    </svg>
                                </button>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex md:flex-row flex-col md:items-center items-start justify-between border border-white rounded p-5">
                <img src="/images/bg-one.png" class="" alt="first_bg" />
            </div>
        </div>
        <div class="grid lg:grid-cols-2 grid-cols-1 gap-5 mx-auto">
            <div class="flex md:flex-row flex-col md:items-center items-start justify-between border border-white rounded p-5">
                <img src="/images/bg-two.png" class="" alt="second_bg" />
            </div>
            <div class="flex md:flex-row flex-col md:items-center items-start justify-between border border-white rounded p-5">
                <div class="lg:w-full w-full left-content pr-5">
                    <div class="lg:-mt-10">
                        <h1 class="lg:text-[50px] text-black text-[40px] font-bold lg:text-left -mt-5">ipNX in a nutshell.</h1>
                        <div class="flex justify-center">
                            <p class="text-black leading-7 text-[16px] font-poppins mt-3 -pt-5 lg:pr-12">ipNX is one of <span class="font-bold">Nigeria’s fastest</span> growing Information and Communications Technology companies, serving a multitude of needs across enterprises, small businesses and residents with <span class="font-bold">innovative, world-class services.</span>

                                <br /><br />Our ability to identify, satisfy and exceed today’s market needs is a testament to over a decade of experience, our commitment, drive and passion realized through <span class="font-bold">highly skilled and well seasoned professionals.</span></p>
                        </div>
                        <div class="mt-3">
                            <a href="https://www.ipnxnigeria.net/our-company/" target="_blank">
                                <button class="md:mt-0 bg-normalRed font-poppins py-2 rounded-[25px] text-white text-[16px] font-medium flex items-center justify-between space-x-0 pl-5">The Full Story
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-5 w-10 text-white">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                                    </svg>
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mx-5 mt-10 mb-10">
            <h3 class="text-black mb-2 mt-5 text-[40px] font-poppins font-bold text-center lg:text-[40px]">Why you should consider applying:</h3>
            <p class="text-black mb-2 mt-5 text-[14px] font-poppins font-bold text-center">We're lively, not corporate. We have the energy and boldness of a startup and the expertise and pragmatism of a scale-up. All in one place.</p>
        </div>
        <div class="flex justify-center mt-5">
            <div class="grid lg:grid-cols-3 grid-cols-1 gap-5">
                <ul>
                    <li class="flex items-start gap-5 py-2">
                        <img src="/images/checkmark-red.png" alt="checkmark">
                        <span class="text-[#000000] text-[14px]">Personal and professional growth</span>
                    </li>
                    <li class="flex items-start gap-5 py-2">
                        <img src="/images/checkmark-red.png" alt="checkmark">
                        <span class="text-[#000000] text-[14px]">Employee wellbeing</span>
                    </li>
                    <li class="flex items-start gap-5 py-2">
                        <img src="/images/checkmark-red.png" alt="checkmark">
                        <span class="text-[#000000] text-[14px]">An open feedback culture</span>
                    </li>
                </ul>
                <ul>
                    <li class="flex items-start gap-5 py-2">
                        <img src="/images/checkmark-red.png" alt="checkmark">
                        <span class="text-[#000000] text-[14px]">A fast-paced tech environment</span>
                    </li>
                    <li class="flex items-start gap-5 py-2">
                        <img src="/images/checkmark-red.png" alt="checkmark">
                        <span class="text-[#000000] text-[14px]">A remote working model</span>
                    </li>
                    <li class="flex items-start gap-5 py-2">
                        <img src="/images/checkmark-red.png" alt="checkmark">
                        <span class="text-[#000000] text-[14px]">Competitive salary</span>
                    </li>
                </ul>
                <ul>
                    <li class="flex items-start gap-5 py-2">
                        <img src="/images/checkmark-red.png" alt="checkmark">
                        <span class="text-[#000000] text-[14px]">Interesting compensation and benefits</span>
                    </li>
                    <li class="flex items-start gap-5 py-2">
                        <img src="/images/checkmark-red.png" alt="checkmark">
                        <span class="text-[#000000] text-[14px]">Personal tooling & training budget</span>
                    </li>
                    <li class="flex items-start gap-5 py-2">
                        <img src="/images/checkmark-red.png" alt="checkmark">
                        <span class="text-[#000000] text-[14px]">Exciting work environment</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="flex justify-center mt-10 mb-10">
            <div class="mt-3">
                <router-link to="/joblistings">
                    <button class="md:mt-0 bg-normalRed font-poppins py-2 rounded-[25px] text-white text-[16px] font-medium flex items-center justify-between space-x-0 pl-5">See Open Roles
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-5 w-10 text-white">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                        </svg>
                    </button>
                </router-link>
            </div>
        </div>
        <div class="mx-5 mt-10">
            <h3 class="text-black mb-2 mt-5 text-[40px] font-poppins font-bold text-center lg:text-[40px]">From candidate to colleague: the different steps.</h3>
            <p class="text-quickNote mb-2 mt-5 text-[14px] font-poppins font-bold text-center">Quick note: we don’t follow these steps all too rigorously but we use them as a framework.</p>
        </div>
        <div class="flex justify-center mt-5">
            <div class="grid lg:grid-cols-3 grid-cols-1 gap-5">
                <ul>
                    <li class="flex items-center justify-center gap-5 py-2">
                        <img src="/images/bi-send-check.svg" alt="checkmark">
                    </li>
                    <li class="flex items-center justify-center gap-5 py-2">
                        <span class="text-[#000000] text-[14px] font-poppins font-bold">1</span>
                    </li>
                    <li class="flex items-center justify-center gap-5 py-2">
                        <span class="text-[#000000] text-[14px] font-poppins font-bold">Apply for a Job</span>
                    </li>
                    <li class="flex items-center justify-center gap-5 py-2">
                        <span class="text-[#6D6B6B] text-[12px] font-poppins">or a spontaneous application</span>
                    </li>
                </ul>
                <ul>
                    <li class="flex items-center justify-center gap-5 py-2">
                        <img src="/images/wi-time.svg" alt="checkmark" style="width: 85px; height: 85px;">
                    </li>
                    <li class="flex items-center justify-center gap-5 py-2">
                        <span class="text-[#000000] text-[14px] font-poppins font-bold">2</span>
                    </li>
                    <li class="flex items-center justify-center gap-5 py-2">
                        <span class="text-[#000000] text-[14px] font-poppins font-bold">Job related</span>
                    </li>
                    <li class="flex items-center justify-center gap-5 py-2">
                        <span class="text-[#6D6B6B] text-[12px] font-poppins">Skill test</span>
                    </li>
                </ul>
                <ul>
                    <li class="flex items-center justify-center gap-5 py-2">
                        <img src="/images/bx-chat.svg" alt="checkmark" style="width: 85px; height: 85px;">
                    </li>
                    <li class="flex items-center justify-center gap-5 py-2">
                        <span class="text-[#000000] text-[14px] font-poppins font-bold">3</span>
                    </li>
                    <li class="flex items-center justify-center gap-5 py-2">
                        <span class="text-[#000000] text-[14px] font-poppins font-bold">In-person interview</span>
                    </li>
                    <li class="flex items-center justify-center gap-5 py-2">
                        <span class="text-[#6D6B6B] text-[12px] font-poppins">with HR & HOD</span>
                    </li>
                </ul>
                <ul>
                    <li class="flex items-center justify-center gap-5 py-2">
                        <img src="/images/chat-bubble-user.svg" alt="checkmark" style="width: 85px; height: 85px;">
                    </li>
                    <li class="flex items-center justify-center gap-5 py-2">
                        <span class="text-[#000000] text-[14px] font-poppins font-bold">4</span>
                    </li>
                    <li class="flex items-center justify-center gap-5 py-2">
                        <span class="text-[#000000] text-[14px] font-poppins font-bold">Executive Chat</span>
                    </li>
                    <li class="flex items-center justify-center gap-5 py-2">
                        <span class="text-[#6D6B6B] text-[12px] font-poppins">with Group Executive Director,<br />HR & Corporate Services</span>
                    </li>
                </ul>
                <ul>
                    <li class="flex items-center justify-center gap-5 py-2">
                        <img src="/images/fluent-person.svg" alt="checkmark" style="width: 85px; height: 85px;">
                    </li>
                    <li class="flex items-center justify-center gap-5 py-2">
                        <span class="text-[#000000] text-[14px] font-poppins font-bold">5</span>
                    </li>
                    <li class="flex items-center justify-center gap-5 py-2">
                        <span class="text-[#000000] text-[14px] font-poppins font-bold">Executive Chat</span>
                    </li>
                    <li class="flex items-center justify-center gap-5 py-2">
                        <span class="text-[#6D6B6B] text-[12px] font-poppins">with Group Managing Director</span>
                    </li>
                </ul>
                <ul>
                    <li class="flex items-center justify-center gap-5 py-2">
                        <img src="/images/document-bullet.svg" alt="checkmark" style="width: 85px; height: 85px;">
                    </li>
                    <li class="flex items-center justify-center gap-5 py-2">
                        <span class="text-[#000000] text-[14px] font-poppins font-bold">6</span>
                    </li>
                    <li class="flex items-center justify-center gap-5 py-2">
                        <span class="text-[#000000] text-[14px] font-poppins font-bold">Kudos, you got the job!</span>
                    </li>
                    <li class="flex items-center justify-center gap-5 py-2">
                        <span class="text-[#6D6B6B] text-[12px] font-poppins">Brace yourself and enjoy the ride</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="flex justify-center mt-10">
            <div class="mt-3">
                <router-link to="/joblistings">
                    <button class="md:mt-0 bg-black font-poppins py-2 rounded-[25px] text-white text-[16px] font-medium flex items-center justify-between space-x-0 pl-5">Apply for Jobs
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-5 w-10 text-white">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                        </svg>
                    </button>
                </router-link>
            </div>
        </div>
        <div class="flex justify-center mt-24 bg-black">
            <div class="grid lg:grid-cols-3 grid-cols-1 gap-5 mt-10 mb-10">
                <ul>
                    <li class="flex items-start gap-5 py-2">
                        <span class="text-[#FFFFFF] text-[20px] font-poppins font-bold">Our Company</span>
                    </li>
                    <li class="flex items-start gap-5 py-2">
                        <a href="https://www.ipnxnigeria.net/our-company/" class="text-[#E1E1E1] text-[14px] font-poppins" target="_blank">About Us</a>
                    </li>
                    <!-- <li class="flex items-start gap-5 py-2">
                        <a href="https://www.ipnxnigeria.net/blog/" class="text-[#E1E1E1] text-[14px] font-poppins" target="_blank">News & Events</a>
                    </li> -->
                    <li class="flex items-start gap-5 py-2">
                        <router-link to="/privacy">
                            <button class="text-[#E1E1E1] text-[14px] font-poppins">Privacy Policy</button>
                        </router-link>
                    </li>
                    <li class="flex items-start gap-5 py-2">
                        <router-link to="/cookie-policy">
                            <button class="text-[#E1E1E1] text-[14px] font-poppins">Cookie Policy</button>
                        </router-link>
                    </li>
                    <li class="flex items-start gap-5 py-2">
                        <a href="https://www.ipnxnigeria.net/csr/" class="text-[#E1E1E1] text-[14px] font-poppins" target="_blank">Corporate Social Responsibility</a>
                    </li>
                    <li class="flex items-start gap-5 py-2">
                        <a href="https://www.ipnxnigeria.net/quality-policy/" class="text-[#E1E1E1] text-[14px] font-poppins" target="_blank">Quality Policy Statement</a>
                    </li>
                </ul>
                <ul class="lg:ml-5">
                    <li class="flex items-start gap-5 py-2">
                        <span class="text-[#FFFFFF] text-[20px] font-poppins font-bold" target="_blank">Residential & SME</span>
                    </li>
                    <li class="flex items-start gap-5 py-2">
                        <a href="https://www.ipnxnigeria.net/home-broadband/" class="text-[#E1E1E1] text-[14px] font-poppins" target="_blank">Residential Broadband</a>
                    </li>
                    <li class="flex items-start gap-5 py-2">
                        <a href="https://www.ipnxnigeria.net/sme-broadband/" class="text-[#E1E1E1] text-[14px] font-poppins" target="_blank">SME Broadband</a>
                    </li>
                    <li class="flex items-start gap-5 py-2">
                        <a href="https://www.ipnxnigeria.net/fos-xtreme/" class="text-[#E1E1E1] text-[14px] font-poppins" target="_blank">FoS Xtreme</a>
                    </li>
                    <li class="flex items-start gap-5 py-2">
                        <a href="https://www.ipnxnigeria.net/help-centre/" class="text-[#E1E1E1] text-[14px] font-poppins" target="_blank">Help Centre</a>
                    </li>
                    <li class="flex items-start gap-5 py-2">
                        <a href="https://www.ipnxnigeria.net/community/" class="text-[#E1E1E1] text-[14px] font-poppins" target="_blank">Community</a>
                    </li>
                </ul>
                <ul class="lg:ml-5">
                    <li class="flex items-start gap-5 py-2">
                        <span class="text-[#FFFFFF] text-[20px] font-poppins font-bold">Enterprise</span>
                    </li>
                    <li class="flex items-start gap-5 py-2">
                        <a href="https://www.ipnxnigeria.net/products-services/" class="text-[#E1E1E1] text-[14px] font-poppins" target="_blank">Products & Services</a>
                    </li>
                    <li class="flex items-start gap-5 py-2">
                        <a href="https://www.ipnxnigeria.net/network/" class="text-[#E1E1E1] text-[14px] font-poppins" target="_blank">Network</a>
                    </li>
                    <li class="flex items-start gap-5 py-2">
                        <a href="https://www.ipnxnigeria.net/support-enterprise/" class="text-[#E1E1E1] text-[14px] font-poppins" target="_blank">Support</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'HeaderComponent',
        data(){
            return {
                mobileMenu: false,
            }
        },
    }
</script>